import { useCallback, useEffect, useState } from "react";
import api from "@/api/client";
import { useAuth } from "@/context/AuthContext";
import { wsPipeline } from "@/lib/workspace";
import { ClipboardCheck } from "lucide-react";

export default function BriefingButton() {
  const { user } = useAuth();
  const [counts, setCounts] = useState(null);

  const load = useCallback(() => {
    if (!user || user.role === "field_agent" || !localStorage.getItem("avida_workspace")) return;
    api
      .get("/me/briefing", { params: { pipeline: wsPipeline() } })
      .then(({ data }) => setCounts(data.counts))
      .catch(() => {});
  }, [user]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const h = () => load();
    window.addEventListener("avida-briefing-updated", h);
    window.addEventListener("focus", h);
    return () => {
      window.removeEventListener("avida-briefing-updated", h);
      window.removeEventListener("focus", h);
    };
  }, [load]);

  if (!user || user.role === "field_agent") return null;
  const overdue = counts?.overdue || 0;

  return (
    <button
      data-testid="briefing-button"
      onClick={() => window.dispatchEvent(new Event("avida-open-briefing"))}
      title="Open my briefing — due, overdue & snoozed"
      className="relative p-2 rounded-md text-white/65 hover:text-[#FFCB05] hover:bg-white/10"
    >
      <ClipboardCheck className="h-4 w-4" />
      {overdue > 0 && (
        <span
          data-testid="briefing-button-count"
          className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 grid place-items-center rounded-full bg-[#b91c1c] text-white text-[9px] font-extrabold ring-2 ring-[#15233B]"
        >
          {overdue}
        </span>
      )}
    </button>
  );
}
